import { useFilters } from "core/features/filters/store";
import { AdvancedFiltersProps } from "../components/concentracao-colheita";

const useAdvancedFiltersNumeroAplicacoes = () => {
  const { updateFiltroNumeroDeAplicacoes, filters } = useFilters();
  const { filtroNumeroDeAplicacoes } = filters;

  const filterSafraPeriodos = filtroNumeroDeAplicacoes?.safraPeriodos;

  const applyFilters = (
    advancedFilters: AdvancedFiltersProps,
    handleCloseModal: () => void
  ) => {
    updateFiltroNumeroDeAplicacoes(
      {
        safraPeriodos: advancedFilters.safraPeriodos,
      },
      true
    );
    handleCloseModal();
  };

  const clearFilters = (
    handleResetFiltersState: (advancedFilters: AdvancedFiltersProps) => void
  ) => {
    updateFiltroNumeroDeAplicacoes(
      {
        safraPeriodos: [],
      },
      true
    );
    handleResetFiltersState({
      safraPeriodos: [],
    });
  };

  return {
    items: {
      filterSafraPeriodos,
    },
    onChange: applyFilters,
    clearFilters,
  };
};

export default useAdvancedFiltersNumeroAplicacoes;
